import { OptionalInformationFormField } from '@exam-center/exam-event-management';
import { Button, Divider, Flex, Paper, SectionTitle } from '@shared/components';
import { type Prettify } from '@shared/utils';
import { type UseFormReturn } from 'react-hook-form';

import { type RecurringExamEventCreationFormType } from '../../providers';
import { BasicInformationFormField } from '../basic-information-form-field';
import { ExamCoursesFormField, type ExamCoursesFormFieldProps } from '../exam-courses-form-field';
import { LocationFormField, type LocationFormFieldProps } from '../location-form-field';
import { ProctorFormField, type ProctorFormFieldProps } from '../proctor-form-field';
import RecurringExamScheduleFormField, {
  type RecurringExamScheduleFormFieldProps,
} from '../recurring-exam-schedule-form-field/recurring-exam-schedule-form-field';
import {
  RegistrationPeriodFormField,
  type RegistrationPeriodFormFieldProps,
} from '../registration-period-form-field';

interface RecurringExamEventCreationFormProps {
  form: UseFormReturn<RecurringExamEventCreationFormType>;
  isCreating?: boolean;
  onCancel?: () => void;
  onSubmit: (data: RecurringExamEventCreationFormType) => void;
  slotProps: Prettify<
    LocationFormFieldProps['slotProps'] &
      ProctorFormFieldProps['slotProps'] &
      ExamCoursesFormFieldProps['slotProps'] &
      RecurringExamScheduleFormFieldProps['slotProps'] &
      RegistrationPeriodFormFieldProps['slotProps']
  >;
}

export default function RecurringExamEventCreationForm(
  props: Readonly<RecurringExamEventCreationFormProps>,
) {
  const { form, isCreating = false, onCancel, onSubmit, slotProps } = props;

  const { isSubmitting } = form.formState;

  return (
    <>
      <Paper
        sx={(theme) => ({
          flex: 1,
          p: theme.spacing(6),
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(6),
          borderRadius: theme.shape.rounded(2),
        })}
      >
        <SectionTitle title='Basic Information' />
        <BasicInformationFormField isShowExamType={false} />
        <Divider />
        <SectionTitle title='Exam Course' />
        <ExamCoursesFormField slotProps={slotProps} />
        <Divider />
        <SectionTitle title='Exam Schedule' />
        <RecurringExamScheduleFormField slotProps={slotProps} />
        <Divider />
        <SectionTitle title='Registration Period' />
        <RegistrationPeriodFormField slotProps={slotProps} />
        <Divider />
        <SectionTitle title='Exam Location' />
        <LocationFormField slotProps={slotProps} />
        <Divider />
        <SectionTitle title='Proctor' />
        <ProctorFormField slotProps={slotProps} />
        <Divider />
        <SectionTitle title='Optional Information' />
        <OptionalInformationFormField />
      </Paper>
      <Flex
        sx={(theme) => ({
          justifyContent: 'flex-end',
          gap: theme.spacing(3),
          pt: theme.spacing(6),
        })}
      >
        <Button
          color='secondary'
          variant='outlined'
          size='large'
          onClick={onCancel}
          disabled={isSubmitting || isCreating}
        >
          ยกเลิก
        </Button>
        <Button
          size='large'
          onClick={() => onSubmit(form.getValues())}
          loading={isCreating}
          disabled={isSubmitting || isCreating}
        >
          สร้างรอบสอบ
        </Button>
      </Flex>
    </>
  );
}
